<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow title="Modifier un propriétaire"/>>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <UserForm
          :userId="this.userId"
          edit="true"
        ></UserForm>

      </b-card>
    </b-container>
  </div>
</template>

<script>
    import BackArrow from "../../components/BackArrow";
    import UserForm from "./UserForm";

    export default {
        name: "UserEdit",

        components: {
            BackArrow,
            UserForm
        },

        data(){
            return {
                userId: this.$route.params.userId,
            }
        },


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserEdit.vue